import Button from 'src/components/Button/Button';
import style from './LinkToAppView.module.scss';
import { ReactComponent as CheckIcon } from 'src/assets/icons/check.svg';

export const LinkToAppView = ({ setCode, submitSignature, loading, code, error }) => {
    return (
        <div className={style.linkToApp}>
            <div className={style.illustration}>
                <img src="/assets/images/connect-wallet-illustration.png" alt="Link wallet illustration" />
            </div>
            <div className={style.form}>
                <div className={style.steps}>
                    <strong>
                        <CheckIcon /> <span>Connect your wallet</span>
                    </strong>
                    <p className={style.before}>
                        This step verifies the authenticity of your wallet and confirms that it truly belongs to you.
                    </p>
                    <strong>
                        <img src="/assets/images/spinner-icon.png" className={style.rotate} alt="Spinner icon" />{' '}
                        <span>Link wallet with the application</span>
                    </strong>
                    <p>On the app, go to Settings &gt; External Wallet Connections, then retrieve your link code.</p>
                </div>
                <div className={style.sign}>
                    <input
                        type="text"
                        placeholder="Your link code"
                        onInput={(e) => setCode(e.target.value)}
                        value={code}
                        className={error ? style.error : undefined}
                    />
                    {error && <p className={style.error}>{error}</p>}
                    <Button onClick={submitSignature} disabled={loading || !code.trim()}>
                        Link my wallet
                    </Button>
                </div>
            </div>
        </div>
    );
};
